import { graphClient } from '../../store/sagas/auth'

const graphRequest = async (siteId, listId, pars = '') => {
  const endpoint = `sites/${siteId}/lists/${listId}/items?${pars}`
  let data
  try {
    const res = await graphClient
      .api(endpoint)
      .header('Prefer', 'HonorNonIndexedQueriesWarningMayFailRandomly')
      .get()
    console.tron.log('res.value graphRequest', res.value)
    const aux = res.value
    data = aux.map(v => v.fields)
  } catch (err) {
    console.tron.log('Houve erro na requisição realizada ao MS Graph.', err)
  }
  return data
}

export default graphRequest

/*
    const siteId = 'ecossissolucoes.sharepoint.com,e13a07f6-096a-45ee-8dfa-74f532b19a7f,ab4a25d0-22db-487b-a5b6-4da8e59bd13c'
    const listId = '24e2b5f2-3b68-40f3-96a8-d154f82986d1'
    const endpoint = `sites/${siteId}/lists/${listId}/items?expand=
        fields(select=id,Title,N_x00fa_meroSEGI)
        &top=9999`
*/
